import axiosInstance from 'src/utils/axios';
import {
  CreateOffsetEmissionRecordPayload,
  CreateQuoteCO2Payload,
  CreateQuoteFootprintPayload,
  QuoteRequest,
} from './types.api';

//
//

const BASE_URL = '/quotes/v1';

//

export const createQuoteByCo2API = async (
  payload: CreateQuoteCO2Payload
): Promise<QuoteRequest> => {
  const response = await axiosInstance.post<QuoteRequest>(
    `${BASE_URL}/co2?warnOnLowInventory=true`,
    payload,
    {}
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const createQuoteByFootprintAPI = async (
  data: CreateQuoteFootprintPayload
): Promise<QuoteRequest> => {
  const response = await axiosInstance.post<QuoteRequest>(
    `${BASE_URL}/footprint?warnOnLowInventory=true`,
    data,
    {}
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const createOffsetEmissionRecordAPI = async (
  payload: CreateOffsetEmissionRecordPayload
): Promise<QuoteRequest> => {
  const { warnOnLowInventory, ...data } = payload;

  const response = await axiosInstance.post<QuoteRequest>(
    BASE_URL + `/emission-record?warnOnLowInventory=${!!warnOnLowInventory}`,
    data,
    {}
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
